<div fxLayout="column">
    <div *ngIf="showHeader" style="margin-bottom: 1rem" fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
        <div *ngIf="metadata.Title !== undefined && metadata.Title.length > 0" class="forge-typography--heading2">
            {{metadata.Title}}
        </div>
        <div *ngIf="!allowPaging" style="height: 0"></div>
        <div fxLayout="row" *ngIf="allowPaging && pagingTop" fxLayoutAlign="start center" fxFlex>
            <forge-paginator (forge-paginator-change)="paginate($event.detail)" [total]="models.length"
                    [pageSize]="rowsPerPage" [pageIndex]="pageIndex" style="position: sticky; right: 24px;" first-last alternative>
            </forge-paginator>
        </div>
        <div *ngIf="!viewOnly && metadata.CanAdd" fxLayoutAlign="start start">
            <forge-button class="panel-grid--add-button" variant="raised" [disabled]="viewOnly || !canAddProperty()" telemetry="Submission-AddItem" (click)="addRow()">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                        <forge-icon name="add" style="--forge-icon-color: var(--forge-theme-on-primary);"></forge-icon>
                        <span>Add</span>
                    </div>
                </forge-button>
        </div>
    </div>
    <forge-divider *ngIf="showHeader" class="forge-card--divider-mb"></forge-divider>
    <div [ngStyle]="{'overflow-x': noWrap ? 'auto' : null}">
        <div fxLayout="row" *ngFor="let model of shownModels; let $index = index" [ngStyle]="{'width': noWrap ? 'max-content' : null}">
            <div class="layout-column layout-fill">
                <div fxLayout="row" [attr.layoutAlign]="layoutAlign">
                    <metadata-panel [viewOnly]="viewOnly || !canEdit(model)" [model]="model" [metadata]="metadata.ClassMetadata" [focusFirst]="focusFirst && (!metadata.CanAdd)" [dense]="dense" [noWrap]="noWrap" [compact]="compact" [datacontroller]="datacontroller" (modifierCallback)="callback($event)" [index]="$index" fxFlex>
                    </metadata-panel>
                    <metadata-panel-grid-actions [model]="model" [metadata]="metadata" [viewOnly]="viewOnly" [index]="getIndex(model)" [canAdd]="canAdd" [hasEditFunction]="hasEditFunction" (deleteAction)="delete($event)" (copyAction)="copy($event)" (customFunction)="fireCustomFunction($event)" (afterAction)="refreshGrid()">
                    </metadata-panel-grid-actions>
                </div>
                <forge-divider [hidden]="$last" class="forge-card--divider-mb"></forge-divider>
            </div>
        </div>
    </div>
    <div fxLayout="row" *ngIf="summaryMetadataExists()">
        <metadata-summary-panel [model]="summaryModel" [metadata]="summaryMetadata" [actionCount]="numberOfActions" fxFlex>
        </metadata-summary-panel>
    </div>
    <div fxLayout="row" *ngIf="allowPaging && !pagingTop" fxLayoutAlign="end center" fxFlex>
        <forge-paginator (forge-paginator-change)="paginate($event.detail)" [total]="models.length"
                [pageSize]="rowsPerPage" [pageIndex]="pageIndex" style="position: sticky; right: 24px;" first-last alternative>
        </forge-paginator>
    </div>
</div>
